'use client';
import { i18nText } from './i18nText';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';
import { sharelinkbylang } from '@/constants';
import EFfbGray from '@/components/UI/svg/Footer/IconNew/EFfbGray';
import EFtwGray from '@/components/UI/svg/Footer/IconNew/EFtwGray';
import EFinsGray from '@/components/UI/svg/Footer/IconNew/EFinsGray';
import EFTiktok from '@/components/UI/svg/Footer/IconNew/EFTiktok';
import EFnofollowGray from '@/components/UI/svg/Footer/IconNew/EFnofollowGray';
import EFLine from '@/components/UI/svg/crowdfunding/EFLine';

const IconList = () => {
    const { locale } = getLocal();
    const { FACEBOOK, TWITTER, INSTAGRAM, YOUTUBE, Tiktok } = sharelinkbylang(locale);

    const list = [
        {
            name: 'Line',
            label: i18nText.LINE,
            href: 'https://lin.ee/NU9u4ah',
            locales: ['jp'],
            component: <EFLine className="img-wrapper" />,
        },
        {
            name: 'Facebook',
            label: i18nText.FACEBOOK,
            href: FACEBOOK,
            component: <EFfbGray className="img-wrapper" />,
        },
        {
            name: 'Twitter',
            label: i18nText.TWITTER,
            href: TWITTER,
            component: <EFtwGray className="img-wrapper" />,
        },
        {
            name: 'Instagram',
            label: i18nText.INSTAGRAM,
            href: INSTAGRAM,
            component: <EFinsGray className="img-wrapper" />,
        },
        {
            name: 'Youtube',
            label: i18nText.YOUTUBE,
            href: YOUTUBE,
            component: <EFnofollowGray className="img-wrapper" />,
        },
        {
            name: 'Tiktok',
            label: i18nText.TIKTOK,
            href: Tiktok,
            locales: ['us', 'ca', 'uk', 'global'],
            component: <EFTiktok className="img-wrapper" />,
        },
    ];

    return (
        <div className="icon-list">
            {list
                .filter((i) => (i.locales ? i.locales.includes(locale) : true))
                .map((i, idx) => (
                    <a
                        className={`icon ${i.name} GtmModuleData-btn-href`}
                        rel="nofollow noreferrer"
                        href={i.href}
                        target="_blank"
                        aria-label={i.label}
                        onClick={() =>
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'ecoflow_social',
                                button_name: i.name,
                                position: 'Homepage_bottom_navigation',

                                __btn_id1: `icon.${i.name}`,
                                __btn_id2: i.href,
                                __btn_type: 'href',
                            })
                        }
                        key={idx}
                    >
                        {i.component}
                    </a>
                ))}
        </div>
    );
};

export default IconList;
